<template>
    <div class="captcha-container">
        <div class="captcha">
            <canvas ref="captchaCanvas" width="320" height="200"></canvas>
            <div class="dragWrapper">
                <div class="slider" @mousedown="startDrag" ref="slider"></div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'Captcha_nm',
        data() {
            return {
                captchaData: null,
                dragging: false,
                offsetX: 0,
                startX: 0,
                correctPos: 0,
                sliderPos: 0,
                tolerance: 30,
                posX: ''
            };
        },
        mounted() {
            this.drawCaptcha();
        },
        methods: {
            drawCaptcha() {
                this.axios.post(this.api_ImgCaptcha, {})
                .then((response) => {
                    this.captchaData = response.data;
                    this.correctPos = this.captchaData.posY;
                    const canvas = this.$refs.captchaCanvas;
                    const ctx = canvas.getContext('2d');
                    const bigImage = new Image();
                    const smallImage = new Image();
                    bigImage.src = `data:image/png;base64,${this.captchaData.bigImageBase64}`;
                    smallImage.src = `data:image/png;base64,${this.captchaData.smallImageBase64}`;
                    bigImage.onload = () => {
                        ctx.clearRect(0, 0, canvas.width, canvas.height);
                        ctx.drawImage(bigImage, 0, 0, canvas.width, canvas.height);
                    };
                    smallImage.onload = () => {
                        ctx.drawImage(smallImage, this.sliderPos, this.correctPos, smallImage.width, smallImage.height);
                    };
                });
            },
            startDrag(e) {
                this.dragging = true;
                this.startX = e.clientX;
                this.offsetX = this.$refs.slider.offsetLeft;
                document.addEventListener('mousemove', this.onDrag);
                document.addEventListener('mouseup', this.stopDrag);
            },
            onDrag(e) {
                if (this.dragging) {
                    const moveX = e.clientX - this.startX;
                    const slider = this.$refs.slider;
                    this.sliderPos = Math.max(0, Math.min(moveX + this.offsetX, 350)); // Giới hạn trong phạm vi
                    slider.style.left = `${this.sliderPos}px`;
                    this.updateCaptchaImage();
                }
            },
            stopDrag() {
                this.dragging = false;
                document.removeEventListener('mousemove', this.onDrag);
                document.removeEventListener('mouseup', this.stopDrag);
                this.posX = this.sliderPos
                if (Math.abs(this.sliderPos - this.correctPos) <= this.tolerance) {
                    console.log('Thành công');
                } else {
                    console.log('Thất bại');
                }
            },
            updateCaptchaImage() {
                const canvas = this.$refs.captchaCanvas;
                const ctx = canvas.getContext('2d');
        
                const bigImage = new Image();
                const smallImage = new Image();
                bigImage.src = `data:image/png;base64,${this.captchaData.bigImageBase64}`;
                smallImage.src = `data:image/png;base64,${this.captchaData.smallImageBase64}`;
                bigImage.onload = () => {
                    ctx.clearRect(0, 0, canvas.width, canvas.height); // Xoá canvas cũ
                    ctx.drawImage(bigImage, 0, 0, canvas.width, canvas.height); // Vẽ full canvas
                };
                smallImage.onload = () => {
                    ctx.drawImage(smallImage, this.sliderPos, this.correctPos, smallImage.width, smallImage.height);
                };
            }
        }
    };
</script>
  
<style scoped>
    .captcha-container {
        position: relative;
        width: 320px;
    }
    .captcha {
        position: relative;
    }
    .dragWrapper{
        width: 100%;
        height: 30px;
        background: red;
    }
    .slider {
        width: 50px;
        height: 30px;
        background-color: #4caf50;
        cursor: pointer;
        position: absolute;
        bottom: 0;
        left: 0;
        border-radius: 5px;
    }
</style>